import { types } from '../../../constants/ActionTypes'

const initialState = {
  open: false,
  url: '',
  shortURL: '',
}

const shareDialog = (state = initialState, action) => {
  switch (action.type) {
    case types.shareDialog.OPEN:
      return { ...state, open: true, shortURL: '' }
    case types.shareDialog.CLOSE:
      return { ...state, open: false }
    case types.shareDialog.MAKED_URL:
      return { ...state, url: action.url }
    case types.bitly.RECEIVE_MAKE_SHORT_URL:
      if (state.open === false || !action.response.link){
        return state
      }
      return { ...state, shortURL: action.response.link }
    default:
      return state
  }
}

export default shareDialog



// WEBPACK FOOTER //
// ./src/reducers/Common/RenjuBoardCard/ShareDialog.js